// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles." + {"272":"60c6bb7f640102e76937","803":"150d71c038637291d73a","866":"644074251879108846dd"}[chunkId] + ".css";
};